import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import DrawerModal from '../../shared/DrawerModal';
import styles from './UpdateInviteCodeModal.styles';
import {
  updateInviteCode,
  selectSelectedInviteCode,
} from '../../../redux/store/userData/circles';
import { getIsVisibleModal, closeModal } from '../../../redux/store/ui/common';
import { useIntl } from 'react-intl';

const UpdateInviteCodeModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const inviteCode = useSelector(selectSelectedInviteCode);
  const visibleModal = useSelector(getIsVisibleModal('updateInviteCodeModal'));
  const [description, setDescription] = useState('');

  useEffect(() => {
    setDescription(inviteCode?.description || '');
  }, [inviteCode, visibleModal]);

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    dispatch(updateInviteCode(inviteCode?.id!, description));
    dispatch(closeModal('updateInviteCodeModal'));
  };

  const handleOnCancel = (e: any) => {
    e.preventDefault();
    dispatch(closeModal('updateInviteCodeModal'));
  };

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('updateInviteCodeModal'));
        }}
      >
        <div className="update-invite-code-modal">
          <div className="input-wrapper">
            <p data-testid="UpdateInviteCodeModal-modalTitle" className="label">
              {intl.formatMessage({
                id: 'fleetadmin.circle.inviteCodes.description',
                defaultMessage: 'Description',
              })}
            </p>
            <Input
              data-testid="UpdateInviteCodeModal-descriptionInput"
              placeholder={intl.formatMessage({
                id: 'fleetadmin.circle.inviteCodes.descriptionPlaceholder',
                defaultMessage: 'Optional description',
              })}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <Button
            data-testid="UpdateInviteCodeModal-submitBtn"
            className="submit-button"
            onClick={handleOnSubmit}
          >
            {intl.formatMessage({ id: 'submit' })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({ id: 'cancel' })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateInviteCodeModal;
